import React, { useEffect } from 'react';
import { Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields1, formFields2 } from './formField';
import { FormField, RadioGroup } from 'components';
import { get, omit, moment } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Upload } from 'components';
import { DownloadedItems } from '../documentsSupplier/components';
import { flattenDocs } from '../documentsSupplier/utils';
import { isBeneficiary } from 'utils';

const ObjectionSupplier = () => {
  const [form] = useForm();
  const task = useSelector(state => state.forms.task);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user?.groups) || task.taskName !== 'task.name.temporary_rejected';
  const carrier = useSelector(state => state.forms.carrier);
  const docs = useSelector(state => state.forms.documents);
  const flatDocs = flattenDocs(docs);
  const dispatch = useDispatch();


  useEffect(() => {
    form.setFieldsValue({
      objCommentBen: carrier.objCommentBen,
    });
  }, [form, carrier]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  return (
    <div>
      <Form
        form={form}
        initialValues={{...carrier }}
        // trigger="onChange"
      >
        <div
          className=""
          // style={{ width: '55%', display: 'inline-block' }}
        >
        <p className="mt-3 mr-0 color-blue-3 text-bold font-size-24">
        Ένσταση Αίτησης 
        </p>
        </div>
        <div
          className=""
          style={{ width: '45%', display: 'inline-block' }}
        >
        {formFields1.map((field, index) => {
          return (
            <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={[field.name]}
                rules={field.rules}
                value={renderFieldValue(field)}
              >
                <FormField
                  key={index}
                  disabled={viewMode}
                  {...omit(field, ['span', 'rules'])}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          );
        })}
        </div>
        <Col>
        <div className='mt-1' style={{ width: '45%', display: 'inline-block' }}>
          {!viewMode ? formFields2.map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
            );
          })
        : 
          <div className='mt-2'>
              <DownloadedItems content={formFields2} docs={flatDocs} />
          </div>
        }
        </div>
        </Col>
      </Form>
    </div>
  );
};

export default ObjectionSupplier;